<template>
  <div class="ws-add-chapter-layer">
    <ValidationObserver ref="form">
      <WsBreadCrumbs :items="_breadcrumbsItems"> </WsBreadCrumbs>
      <WsTitle v-if="_editType==='updateCurrentVersion'">編輯當前版本題目</WsTitle>
      <WsTitle v-else-if="_editType==='createVersion'">更新題目版本</WsTitle>
      <div v-if="isLoading">
        <v-skeleton-loader
          v-for="n in 3"
          :key="`skeleton-${n}`"
          type="list-item-three-line"
          :tile="true"
          class="mt-5"
        ></v-skeleton-loader>
      </div>
      <WsInfiniteLayers2
        :layers="_layers"
        :modelName="modelName"
        :parentModelData="parentModelData"
        :editType="_editType"
        v-model="state.infiniteLayers"
      ></WsInfiniteLayers2>
    </ValidationObserver>
    <WsMainBottomNav>
      <WsBtn
        color="textSecondary"
        outlined
        :loading="isLoading ||submitLoading"
        @click="$router.go(-1)"
      >取消</WsBtn>
      <WsBtn
        :loading="isLoading ||submitLoading"
        @click="$_onSubmit()"
      >送出</WsBtn>
    </WsMainBottomNav>
  </div>
</template>

<script>
export default {
  data: () => ({
    modelData: null,
    parentModelData: null,
    isLoading: false,
    submitLoading: false,
    state: {
      infiniteLayers: [],
    },
    layers: [
      {
        btnAddText: "新增章",
        btnAddIcon: "mdi-plus",
        btnAddColor: "primary",
        btnAddOutline: true,
        component: "WsTitleInput",
        props: {
          type: 'chapter',
          title: "章",
          fields: {
            name: {
              label: "",
              type: "text",
              sm: 12,
            },
          },
          description: '請再三確認，章以下的題目也會一併刪除。'
        },
      },
      {
        btnAddText: "新增節",
        btnAddIcon: "mdi-plus",
        btnAddColor: "primary",
        btnAddOutline: true,
        component: "WsTitleInput",
        props: {
          type: 'section',
          title: "節",
          fields: {
            name: {
              label: "",
              type: "text",
              sm: 12,
            },
          },
          description: '請再三確認，節以下的題目也會一併刪除。'
        },
      },
      {
        btnAddText: "新增題目",
        btnAddIcon: "mdi-plus",
        btnAddColor: "primary",
        btnAddOutline: true,
        component: "WsAppQuestion",
        props: {
          title: "題目",
          fields: {
            name: {
              label: "",
              type: "text",
              sm: 12,
            },
            attaches: {
              type: "files",
              label: "查核提示附件",
              uploadUrl: "/audit_question_template_version/attach/",
            },
            effects: {
              label: "風險燈號",
              type: "hasMany",
              modelName: "effect",
              textKey: "name",
              sm: 6,
            },
          },
        },
      },
    ],
  }),
  methods: {
    async $_fetchData() {
      this.$store.dispatch("locale/changeLanguageDisable");
      this.isLoading = true;
      //give modelName
      try {
        await this.$_parentModelData();
        //get model data
        let params = {};
        params[`${this.parentVersionModelName}s`] =
          this.$route.params.version_id
        try {
          await this.$_getModelData(`/${this.modelName}`, params);
          //如果api已經有值就給值
          if (
            this.parentModelData &&
            this.parentModelData.chapters
          ) {
            this.state.infiniteLayers = this.$_changeToState();
          }
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          alert(error);
        }
      } catch (error) {
        this.isLoading = false;
        alert(error);
      }
    },
    async $_getModelData(getUrl, params) {
      try {
        const res = await this.$axios.get(getUrl, { params: params });
        this.modelData = res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    async $_parentModelData() {
      this.$store.dispatch("app/startPageLoading");
      let url = `/${this.parentModelName}/${this.$route.params.id}`
      let versionUrl = `/${this.parentVersionModelName}/${this.$route.params.version_id}`;
      if (this.localeMode) {
        url += `?locale=${this._selectingLocale}`
        versionUrl += `?locale=${this._selectingLocale}`;
      }
      try {
        const res = await this.$axios.get(url)
        const versionRes = await this.$axios.get(versionUrl);
        if (this.customParentData) {
          this.parentModelData = this.customParentData(res.data.data, versionRes.data.data)
        } else {
          this.parentModelData = versionRes.data.data;
        }
      } catch (error) {
        alert(error);
      } finally {
        this.$store.dispatch("app/stopPageLoading");
      }
    },
    async $_onSubmit() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return;
      }
      this.submitLoading = true;
      const parentModelVersionId = this.parentModelData.last_version
        ? this.parentModelData.last_version.id
        : this.parentModelData.id
      try {
        //post question_template
        //新增題目 沒有id時
        let postUrl;
        let modelTasks = [];
        postUrl = `/${this.modelName}`;
        let _state = {};
        _state.chapters = this.$_changeToChapters();
        _state.chapters.forEach((chapterItem) => {
          chapterItem.sections.forEach((sectionItem) => {
            sectionItem.topics.forEach((topicItem) => {
              if (!topicItem.id) {
                let newObject = {};
                newObject[`${this.parentModelName}s`] = [this.$route.params.id];
                newObject[`${this.parentVersionModelName}s`] =
                  [parentModelVersionId];
                modelTasks.push(() => this.$axios.post(postUrl, newObject));
              }
            });
          });
        });
        const modelRes = [];
        for (const task of modelTasks) {
          const result = await task();
          modelRes.push(result);
          // 等待 500ms 再執行下一個 task
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        //新增題目的新id放到state
        //update topic.id of this.state
        let modelResIndex = 0;
        _state.chapters.forEach((chapterItem) => {
          chapterItem.sections.forEach((sectionItem) => {
            sectionItem.topics.forEach((topicItem) => {
              if (!topicItem.id) {
                topicItem.id = modelRes[modelResIndex].data.data.id;
                modelResIndex++;
              }
            });
          });
        });
        try {
          //post 公版版本
          //post template_version
          let params = {};
          params[`${this.parentVersionModelName}s`] = parentModelVersionId
          await this.$_getModelData(`/${this.modelName}`, params);
          let newObject = {};
          newObject.chapters = [];
          let modelArr = [];
          let modelVersionArr = [];
          newObject[`${this.modelName}s`] = [];
          newObject[`${this._versionModelName}s`] = [];
          _state.chapters.forEach((chapterItem, chapterIndex) => {
            newObject.chapters.push({
              badId: chapterItem.badId,
              chapterTitle: chapterItem.chapterTitle,
              sections: [],
            });
            if (this.parentModelData.sequence) {
              newObject.sequence = this.parentModelData.sequence;
            }
            if (this.parentModelData.last_version && this.parentModelData.last_version.locales) {
              newObject.locales = this.parentModelData.last_version.locales;
            } else if (this.parentModelData.locales) {
              newObject.locales = this.parentModelData.locales;
            }
            chapterItem.sections.forEach((sectionItem, sectionIndex) => {
              let sectionObject = {};
              sectionObject["badId"] = sectionItem.badId;
              sectionObject["sectionTitle"] = sectionItem.sectionTitle;
              sectionObject["topics"] = [];
              newObject.chapters[chapterIndex].sections.push(sectionObject);
              sectionItem.topics.forEach((topicItem) => {
                this.modelData.forEach((modelItem) => {
                  if (modelItem.id === topicItem.id) {
                    newObject.chapters[chapterIndex].sections[
                      sectionIndex
                    ].topics.push({
                      id: modelItem.id,
                    });
                    modelArr.push(modelItem.id);
                    if (modelItem.last_version) {
                      modelVersionArr.push(modelItem.last_version.id);
                    }
                  }
                });
              });
            });
          });
          //@@@
          newObject[`${this.modelName}s`] = modelArr;
          newObject[`${this._versionModelName}s`] = modelVersionArr;
          //if have add chapter ever
          await this.$axios.patch(
            `/${this.parentVersionModelName}/${parentModelVersionId}`,
            newObject
          );
        try {
          //post question_template's version
          let questionVersionTasks = [];
          // 建立 modelData 的 Map 以提升查詢效能
          const modelDataMap = new Map();
          if (this.modelData && this.modelData.length) {
            this.modelData.forEach(item => {
              modelDataMap.set(item.id, item);
            });
          }
          _state.chapters.forEach(chapterItem => {
            chapterItem.sections.forEach(sectionItem => {
              sectionItem.topics.forEach(topicItem => {
                const modelItem = modelDataMap.get(topicItem.id);
                if (modelItem) {
                  let newObject = JSON.parse(
                    JSON.stringify(topicItem.last_version)
                  );
                  newObject.payload = {
                    chapterId: chapterItem.badId,
                    sectionId: sectionItem.badId,
                  };
                  newObject[this.modelName] = modelItem.id;
                  if (topicItem.status) {
                    newObject.status = 1;
                  }
                  if (
                    (this._editType === "createVersion" &&
                      topicItem.isCreateVersion) ||
                    !modelItem.last_version
                  ) {
                    questionVersionTasks.push(() =>
                      this.$axios.post(
                        `/${this._versionModelName}`,
                        newObject
                      )
                    );
                  } else {
                    if (this._editType === "createVersion") {
                      return;
                    }
                    questionVersionTasks.push(() =>
                      this.$axios.patch(
                        `/${this._versionModelName}/${modelItem.last_version.id}`,
                        newObject
                      )
                    );
                  }
                }
              });
            });
          });
            const resOfQuestionVersion = [];
            for (const task of questionVersionTasks) {
              const result = await task();
              resOfQuestionVersion.push(result);
              // 等待 500ms 再執行下一個 task
              await new Promise(resolve => setTimeout(resolve, 500));
            }
            // 收集所有成功創建的ID
            const successIds = resOfQuestionVersion
              .filter(data => data.statusText === 'Created' && data.status === 201)
              .map(data => data.data.data.id);

            // 如果有成功創建的項目，一次性更新
            if (successIds.length > 0) {
              modelVersionArr.push(...successIds);
              newObject[`${this._versionModelName}s`] = modelVersionArr;
              await this.$axios.patch(
                `/${this.parentVersionModelName}/${parentModelVersionId}`,
                newObject
              );
            }
            //post done
            this.submitLoading = false;
            this.$store.dispatch("app/stopNeedSave");
            this.$router.push(
              `/${this.parentModelName}/${this.$route.params.id}`
            );
          } catch (error) {
            alert('題目版本儲存發生錯誤: ' + error);
            this.submitLoading = false;
          }
        } catch (error) {
          alert('公版版本儲存發生錯誤: ' + error);
          this.submitLoading = false;
        }
      } catch (error) {
        alert('題目儲存發生錯誤: ' + error);
        this.submitLoading = false;
      }
    },
    $_changeToChapters() {
      if (!this.state.infiniteLayers.length) return;
      const _state = { ...this.state };
      let _data = [];
      _data = _state.infiniteLayers.map((layerMap) => {
        let date = new Date();
        let randomId = `${date.getFullYear()}${date.getMonth()}${date.getDate()}${date.getMinutes()}${Math.random()
          .toString(36)
          .substring(9)}`;
        const _badId = layerMap.state.badId || `c${randomId}`;
        return {
          //badId超過來創立，或判斷layrtMap有沒有badId
          badId: _badId,
          chapterTitle: layerMap.state.name,
          sections: layerMap.items.map((sectionMap) => {
            let date = new Date();
            let randomId = `${date.getFullYear()}${date.getMonth()}${date.getDate()}${date.getMinutes()}${Math.random()
              .toString(36)
              .substring(10)}`;
            const _badId = sectionMap.state.badId || `s${randomId}`;
            return {
              badId: _badId,
              sectionTitle: sectionMap.state.name,
              topics: sectionMap.items.map((questionMap) => {
                return {
                  ...questionMap.state,
                };
              }),
            };
          }),
        };
      });
      return _data;
    },
    $_changeToState() {
      if (!this.parentModelData || !this.modelData) return;
      const _parentModelData = { ...this.parentModelData };
      let _data = [];

      _data = _parentModelData.chapters.map((chapterMap) => {
        return {
          state: {
            badId: chapterMap.badId,
            name: chapterMap.chapterTitle,
          },
          items: chapterMap.sections.map((sectionsMap) => {
            return {
              state: {
                badId: sectionsMap.badId,
                name: sectionsMap.sectionTitle,
              },
              items: sectionsMap.topics.map((questionMap) => {
                const _index = this.modelData.findIndex((e) => {
                  return e.id == questionMap.id;
                });
                if (_index >= 0) {
                  return {
                    state: {
                      id: questionMap.id,
                      last_version: this.modelData[_index].last_version,
                    },
                  };
                } else {
                  return {
                    state: {
                      id: questionMap.id,
                    },
                  };
                }
              }),
            };
          }),
        };
      });
      return _data;
    },
  },
  computed: {
    _breadcrumbsItems() {
      if (!this.parentModelData) {
        return [];
      }
      if (!this.parentModelData.last_version) {
        return [];
      }
      const _breadcrumbsItems = [];
      _breadcrumbsItems.push({
        text: this.label,
        to: `/${this.parentModelName}`,
        disabled: false,
      });
      _breadcrumbsItems.push({
        text: this.parentModelData.name,
        to: `/${this.parentModelName}/${this.$route.params.id}`,
        disabled: false,
      });
      if (this._editType === "updateCurrentVersion") {
        _breadcrumbsItems.push({
          text: "編輯當前版本題目",
          disabled: true,
        });
      } else if (this._editType === "createVersion") {
        _breadcrumbsItems.push({
          text: "更新題目版本",
          disabled: true,
        });
      }
      return _breadcrumbsItems;
    },

    _editType() {
      if (this.editType) {
        return this.editType;
      } else if (this.parentModelData && this.parentModelData.last_version) {
        if (this.parentModelData.last_version.version_status) {
          return "updateCurrentVersion";
        } else {
          return "createVersion";
        }
      } else {
        return "updateCurrentVersion";
      }
    },
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _versionModelName() {
      return `${this.modelName}_version`;
    },
    _layers() {
      const _layers = [...this.layers];
      _layers[2].props.fields = this.fields;
      if (this.customParentData) {
        _layers[2].props.customParentData = this.customParentData;
      }
      return _layers;
    },
  },
  created() {
    this.$_fetchData();
    this.$_changeToState();
  },
  props: {
    fields: {
      type: Object,
    },
    editType: {
      type: String,
      default: "",
    },
    parentVersionModelName: {
      type: String,
    },
    parentModelName: {
      type: String,
    },
    modelName: {
      type: String,
    },
    label: {
      type: String,
    },
    localeMode: {
      type: Boolean,
      default: false,
    },
    customParentData: {
      type: Function,
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-add-chapter-layer.scss";
</style>